import { useQuery } from '@tanstack/react-query';
import { IJob as IJobModel } from '~/models';
import { jobKeys } from '../jobKeys';
import { jobsService } from '../jobsService';

interface IUseCandidateOvertimeOptions {
  enabled?: boolean;
}

export function useCandidateOvertime(
  jobId?: string,
  candidateId?: string,
  options: IUseCandidateOvertimeOptions = {},
) {
  return useQuery<Partial<IJobModel>>({
    queryKey: jobKeys.candidateOvertime(jobId ?? '', candidateId ?? ''),
    queryFn: () => jobsService.getCandidateOvertime(jobId!, candidateId!),
    enabled: Boolean(jobId && candidateId) && (options.enabled ?? true),
    staleTime: 1000 * 30,
    gcTime: 1000 * 60 * 2,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
